import { render, staticRenderFns } from "./ProductReports.vue?vue&type=template&id=0f0de33c&"
import script from "./ProductReports.vue?vue&type=script&lang=js&"
export * from "./ProductReports.vue?vue&type=script&lang=js&"
import style0 from "./ProductReports.vue?vue&type=style&index=0&id=0f0de33c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports